import axios from '@/utils/http';

export default (advertisementId, status) => {
  return axios
    .put(`/advertisement/${advertisementId}/change_status`, { status })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
